<template>
  <div>
    <!-- h5页面 -->
    <div class="articles">
      <h1 class="title">精彩文章</h1>
      <section class="wrap">
        <div class="item" v-for="(item,index) in filterList" :key="index" @click="go(item)">
          <img class="img" :src="item.img" alt />
          <p class="item-title">{{item.title}}</p>
          <p class="text">{{item.desc}}</p>
        </div>
      </section>
      <p class="load-more" @click="showMore" v-if="!moreStatus">查看更多</p>
      <p class="hide-more" @click="hideMore" v-if="moreStatus">收起</p>
    </div>
    <!-- pc页面 -->
    <div class="articles-pc">
      <div class="articles-wrap">
        <header class="header">
          <h1 class="title">精彩文章</h1>
          <div class="set" v-show="list.length>4">
            <div class="articles-prev prev" slot="button-prev"></div>
            <div class="articles-next next" slot="button-next"></div>
          </div>
        </header>
        <!-- 轮播结构 -->
        <div class="swiper-wrap">
          <swiper :options="swiperOptionTop" class="gallery-top">
            <swiper-slide :key="index" v-for="(item ,index) in list">
              <div class="item">
                <img class="img" :src="item.img" alt />
                <p class="item-title">{{item.title}}</p>
                <p class="text">{{item.desc}}</p>
                <p class="btn" @click="go(item)">查看详情</p>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import XHR from '../api'

export default {
  name: 'Articles',
  props: [],
  data: () => ({
    list: [],
    moreStatus: false, // 查看更多按钮状态
    swiperOptionTop: {
      slidesPerView: 4, // 视图内最大数
      spaceBetween: 40, // 间隔
      navigation: {
        nextEl: '.articles-next',
        prevEl: '.articles-prev'
      }
    }
  }),
  components: {
    swiper,
    swiperSlide
  },
  created () {
  },
  mounted () {
    this.getHandWork()
  },
  computed: {
    // 查看更多切换
    filterList: function () {
      if (!this.moreStatus) {
        return this.list.slice(0, 4)
      }
      return this.list
    }
  },
  methods: {
    // 获取手工位
    getHandWork () {
      XHR.getHandWork({
        type: 9,
        hid: 4119
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.list = data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    showMore () {
      this.moreStatus = true
    },
    hideMore () {
      this.moreStatus = false
    },
    // 跳转
    go (item) {
      this.sendAnalytics('配件新零售招商专题活动', '查看文章', item.link)
      window.location.href = item.link
    }
  }
}
</script>
<style lang="less" scoped>
.articles {
  width: 100%;
  background: #f4f5f6;
  .title {
    font-size: 24px;
    color: #000000;
    line-height: 30px;
    padding: 28px 0 20px;
    text-align: center;
  }
  .wrap {
    // width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    justify-content: space-between;
    .item {
      background: #ffffff;
      border-radius: 4px;
      width: 174px;
      height: 256px;
      margin-bottom: 8px;
      .img {
        height: 116px;
        width: 100%;
        border-radius: 4px 4px 0 0;
      }
      p {
        padding: 0 12px;
        &.item-title {
          flex: 1;
          margin-top: 12px;
          font-size: 16px;
          color: #000000;
          line-height: 21px;
          font-weight: bold;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        &.text {
          margin-top: 8px;
          font-size: 14px;
          color: #6d7278;
          height: 60px;
          line-height: 20px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
  .load-more {
    padding: 20px 0;
    font-size: 14px;
    color: #3d72f5;
    text-align: center;
    line-height: 18px;
    &::after {
      margin-left: 4px;
      content: "\e7fc";
      display: inline-block;
      font-family: "iconfont";
    }
  }
  .hide-more {
    padding: 20px 0;
    font-size: 14px;
    color: #3d72f5;
    text-align: center;
    line-height: 18px;
    &::after {
      margin-left: 4px;
      content: "\e7f0";
      display: inline-block;
      font-family: "iconfont";
    }
  }
}
.articles-pc {
  width: 100%;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-image: url("https://s.kcimg.cn/topic/images/new-retail/articles-bg.png");
  background-color: #f4f5f6;
  .articles-wrap {
    width: 1200px;
    margin: auto;
    .header {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .title {
        font-size: 40px;
        color: #000000;
        text-align: left;
        line-height: 50px;
        padding: 60px 0 0 0;
      }
      .set {
        display: flex;
        justify-content: center;
        align-items: center;
        .prev {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: #3d72f5;
          text-align: center;
          line-height: 30px;
          color: #ffffff;
          font-size: 12px;
          outline: none;
          transition: background 0.1s;
          &:hover {
            background: #09dda8;
          }
          &::before {
            content: "\e7fa";
            display: inline-block;
            font-family: "iconfont";
          }
        }
        .next {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: #3d72f5;
          text-align: center;
          line-height: 30px;
          color: #ffffff;
          font-size: 12px;
          outline: none;
          margin-left: 10px;
          transition: background 0.1s;
          &:hover {
            background: #09dda8;
          }

          &::before {
            content: "\e7fb";
            display: inline-block;
            font-family: "iconfont";
          }
        }
      }
    }
    .swiper-wrap {
      .swiper-slide {
        margin-top: 30px;
        transition: margin 0.1s;
        &:hover {
          margin-top: 19px;
          .item {
            box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
          }
        }
        .item {
          position: relative;
          display: flex;
          flex-direction: column;
          background: #ffffff;
          border-radius: 8px;
          width: 270px;
          min-height: 406px;
          margin-bottom: 60px;
          .img {
            width: 100%;
            height: 180px;
            border-radius: 8px 8px 0 0;
          }
          p {
            padding: 0 18px;
            &.item-title {
              margin-top: 20px;
              font-size: 18px;
              color: #000000;
              line-height: 24px;
              font-weight: bold;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            &.text {
              flex: 1;
              margin-top: 10px;
              font-size: 14px;
              color: #6d7278;
              line-height: 22px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
          .btn {
            display: inline-block;
            padding: 0 18px;
            margin: 20px 0 30px;
            background: #ffffff;
            font-size: 14px;
            color: #3d72f5;
            line-height: 32px;
            cursor: pointer;
            &::after {
              margin-left: 4px;
              content: "\e7fb";
              display: inline-block;
              font-family: "iconfont";
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 376px) {
  .articles-pc {
    display: block;
  }
  .articles {
    display: none;
  }
}
@media screen and (max-width: 375px) {
  .articles-pc {
    display: none;
  }
  .articles {
    display: block;
  }
}
</style>
